module.exports = __webpack_public_path__ + "img/set_wallpaper_2.b589ef3d.png";